import axiosInstance from '@/utils/api.js'

var state = {
  ipTrafficServiceLink: []
}

var getters = {
  IP_TRAFFIC_SERVICE_LINK: (state) => {
    return state.ipTrafficServiceLink
  }
}

var mutations = {
  SET_IP_TRAFFIC_SERVICE_LINK: (state, payload) => {
    state.ipTrafficServiceLink = payload || []
  }
}

var actions = {
  GET_IP_TRAFFIC_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/iptraffic?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_IP_TRAFFIC_SERVICE_LINK', result.data)
    }
  },
  CREATE_IP_TRAFFIC_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/iptraffic', payload)
  },
  UPDATE_IP_TRAFFIC_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/iptraffic', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkIPTraffic.js